import { SVGProps } from 'react';

export const QuickchatAiIcon = (props: SVGProps<any>) => (
  <svg
    width="137"
    height="31"
    viewBox="0 0 137 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M111.049 19.5082V10.2694H112.847V19.5082H111.049ZM111.013 8.88533V6.76434H112.883V8.88533H111.013Z"
      fill="currentColor"
    />
    <path
      d="M103.812 19.7411C101.961 19.7411 100.648 18.5368 100.648 16.8113C100.648 15.0857 101.925 14.0792 103.704 13.8994L106.85 13.5759C106.832 12.4794 106.041 11.6167 104.657 11.6167C103.381 11.6167 102.769 12.4255 102.608 13.1625L101.008 12.6951C101.421 11.0774 102.751 10.0349 104.657 10.0349C107.353 10.0349 108.611 11.8324 108.611 13.6837V19.5074H106.832V16.6675C106.832 18.6267 105.573 19.7411 103.812 19.7411ZM102.446 16.8113C102.446 17.692 103.201 18.2492 104.189 18.2492C106.095 18.2492 106.85 16.8652 106.85 15.5531V15.0498L104.1 15.3374C103.003 15.4632 102.446 15.9665 102.446 16.8113Z"
      fill="currentColor"
    />
    <path d="M96.5114 19.5078V17.0812H98.7402V19.5078H96.5114Z" fill="currentColor" />
    <path
      d="M92.7327 19.5097C91.2948 19.5097 90.2163 18.7547 90.2163 17.0112V11.8525H88.5986V10.2708H90.2523V8.18576H92.0137V10.2708H94.7638V11.8525H92.0137V16.9213C92.0137 17.6403 92.3912 17.9099 92.9484 17.9099H94.6021V19.5097H92.7327Z"
      fill="currentColor"
    />
    <path
      d="M82.1366 19.7411C80.2852 19.7411 78.9731 18.5368 78.9731 16.8113C78.9731 15.0857 80.2493 14.0792 82.0287 13.8994L85.1743 13.5759C85.1563 12.4794 84.3654 11.6167 82.9814 11.6167C81.7052 11.6167 81.0941 12.4255 80.9323 13.1625L79.3326 12.6951C79.746 11.0774 81.0761 10.0349 82.9814 10.0349C85.6775 10.0349 86.9358 11.8324 86.9358 13.6837V19.5074H85.1563V16.6675C85.1563 18.6267 83.8981 19.7411 82.1366 19.7411ZM80.7705 16.8113C80.7705 17.692 81.5254 18.2492 82.514 18.2492C84.4193 18.2492 85.1743 16.8652 85.1743 15.5531V15.0498L82.4242 15.3374C81.3277 15.4632 80.7705 15.9665 80.7705 16.8113Z"
      fill="currentColor"
    />
    <path
      d="M68.8535 19.5087V6.92657H70.6509V13.2176C70.7228 11.546 71.8192 10.0362 73.6886 10.0362C75.8096 10.0362 76.924 11.6359 76.924 13.3974V19.5087H75.1265V13.9186C75.1265 12.6424 74.1739 11.7437 72.9696 11.7437C71.5856 11.7437 70.6509 12.7503 70.6509 14.1164V19.5087H68.8535Z"
      fill="currentColor"
    />
    <path
      d="M62.5075 19.7411C59.7035 19.7411 57.6904 17.674 57.6904 14.888C57.6904 12.102 59.7395 10.0349 62.5075 10.0349C64.4128 10.0349 66.0485 10.9696 66.7854 12.785L65.2396 13.5939C64.9161 12.5873 63.8915 11.6886 62.5075 11.6886C60.782 11.6886 59.5238 13.0187 59.5238 14.888C59.5238 16.8293 60.8359 18.0875 62.5075 18.0875C63.7657 18.0875 64.9161 17.4224 65.3834 16.0743L66.9113 16.7933C66.1923 18.8064 64.4667 19.7411 62.5075 19.7411Z"
      fill="currentColor"
    />
    <path
      d="M48.9996 19.5087V6.92657H50.797V17.5674C50.797 14.7455 51.462 13.6131 52.7742 12.229L54.7334 10.2698H57.0341L53.637 13.7748L57.2318 19.5087H55.1468L52.3787 15.069C51.8036 15.6622 50.797 16.8664 50.797 19.1132V19.5087H48.9996Z"
      fill="currentColor"
    />
    <path
      d="M42.6554 19.7411C39.8514 19.7411 37.8383 17.674 37.8383 14.888C37.8383 12.102 39.8874 10.0349 42.6554 10.0349C44.5607 10.0349 46.1964 10.9696 46.9334 12.785L45.3876 13.5939C45.064 12.5873 44.0395 11.6886 42.6554 11.6886C40.9299 11.6886 39.6717 13.0187 39.6717 14.888C39.6717 16.8293 40.9838 18.0875 42.6554 18.0875C43.9137 18.0875 45.064 17.4224 45.5314 16.0743L47.0592 16.7933C46.3402 18.8064 44.6147 19.7411 42.6554 19.7411Z"
      fill="currentColor"
    />
    <path
      d="M34.1852 19.5082V10.2694H35.9826V19.5082H34.1852ZM34.1492 8.88533V6.76434H36.0186V8.88533H34.1492Z"
      fill="currentColor"
    />
    <path
      d="M31.7738 10.2709V19.5098H29.9764V16.5799C29.8685 18.2336 28.7541 19.7434 26.8488 19.7434C24.7099 19.7434 23.7033 18.1617 23.7033 16.3822V10.2709H25.5007V15.861C25.5007 17.2989 26.4174 18.0359 27.6217 18.0359C29.0057 18.0359 29.9764 17.0293 29.9764 15.6812V10.2709H31.7738Z"
      fill="currentColor"
    />
    <path
      d="M16.7812 11.6706C15.0916 11.6706 13.8334 12.9108 13.8334 14.888C13.8334 16.8113 15.0916 18.1054 16.7453 18.1054C18.345 18.1054 19.6931 16.9371 19.6931 14.888C19.6931 13.0906 18.5067 11.6706 16.7812 11.6706ZM12 14.888C12 12.1199 13.7615 10.0349 16.0982 10.0349C18.2192 10.0349 19.3695 11.5627 19.6212 13.6118V10.2686H21.4006V23.2821H19.6212V16.326C19.3695 18.4469 17.9495 19.7411 16.0982 19.7411C13.7255 19.7411 12 17.71 12 14.888Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M113.001 23.3633H100.608V21.711H113.001V23.3633Z"
      fill="currentColor"
    />
  </svg>
);
